import {
  NameSpecifiedEntity,
} from "../entity";
import {
  Profession,
} from ".";

export class User extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string, public profession: Profession, public kanaName: string, public email: string, public phone: string) {
    super(id, name);
  }

  get nameAndPhoneNumber(): string {
    return this.phone
      ? this.name + "(" + this.phone + ")"
      : this.name;
  }
}
